import { IPropertyInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { ITypeInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/EntityBaseProperties";

export interface IClientSatisfactionQuestionnaireProperties extends IEntityBaseProperties
{

    // #region Basic Properties

    caseId: IPropertyInfoMetadata;
    name: IPropertyInfoMetadata;
    meetingDate: IPropertyInfoMetadata;
    mediatorName: IPropertyInfoMetadata;
    sourceLookupItemId: IPropertyInfoMetadata;
    sourceOther: IPropertyInfoMetadata;
    quickReplyRatingLookupItemId: IPropertyInfoMetadata;
    contactCaseManagerRatingLookupItemId: IPropertyInfoMetadata;
    happyWithSupportRatingLookupItemId: IPropertyInfoMetadata;
    clearInformationAboutMeetingRatingLookupItemId: IPropertyInfoMetadata;
    caseManagementTeamHelpComments: IPropertyInfoMetadata;
    helpWithTechnologyDuringMeetingRatingLookupItemId: IPropertyInfoMetadata;
    offeredConversationWithMediatorBeforeMeetingRatingLookupItemId: IPropertyInfoMetadata;
    mediatorHelpBeforeMeetingComments: IPropertyInfoMetadata;
    mediatorHelpedMeFeelSafeAndComfortableRatingLookupItemId: IPropertyInfoMetadata;
    mediatorWasFairRatingLookupItemId: IPropertyInfoMetadata;
    mediatorListenedRatingLookupItemId: IPropertyInfoMetadata;
    mediatorMadeSurePointsHeardRatingLookupItemId: IPropertyInfoMetadata;
    happenNextRatingLookupItemId: IPropertyInfoMetadata;
    commentsAboutMediator: IPropertyInfoMetadata;
    mediationHelpfulRatingLookupItemId: IPropertyInfoMetadata;
    recommendMediationRatingLookupItemId: IPropertyInfoMetadata;
    meetingComments: IPropertyInfoMetadata;
    suggestions: IPropertyInfoMetadata;
    canContact: IPropertyInfoMetadata;
    canShareFeedback: IPropertyInfoMetadata;
    canUseNameOrOrganisationsName: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Properties

    case: IPropertyInfoMetadata;
    clearInformationAboutMeetingRatingLookupItem: IPropertyInfoMetadata;
    contactCaseManagerRatingLookupItem: IPropertyInfoMetadata;
    happenNextRatingLookupItem: IPropertyInfoMetadata;
    happyWithSupportRatingLookupItem: IPropertyInfoMetadata;
    helpWithTechnologyDuringMeetingRatingLookupItem: IPropertyInfoMetadata;
    mediationHelpfulRatingLookupItem: IPropertyInfoMetadata;
    mediatorHelpedMeFeelSafeAndComfortableRatingLookupItem: IPropertyInfoMetadata;
    mediatorListenedRatingLookupItem: IPropertyInfoMetadata;
    mediatorMadeSurePointsHeardRatingLookupItem: IPropertyInfoMetadata;
    mediatorWasFairRatingLookupItem: IPropertyInfoMetadata;
    offeredConversationWithMediatorBeforeMeetingRatingLookupItem: IPropertyInfoMetadata;
    quickReplyRatingLookupItem: IPropertyInfoMetadata;
    recommendMediationRatingLookupItem: IPropertyInfoMetadata;
    sourceLookupItem: IPropertyInfoMetadata;

    // #endregion

}

export const ClientSatisfactionQuestionnaire: ITypeInfoMetadata<IClientSatisfactionQuestionnaireProperties> = {
    attributes: [
        {
            id: "{E257580E-0E4A-4F12-9858-2AF03BAC0FA4}",
            $type: "SeriouslyRAD.Framework.ClientAwareIdAttribute, SeriouslyRAD.Framework"
        },
        {
            name: "ClientSatisfactionQuestionnaire",
            nameFriendly: "Client Satisfaction Questionnaire",
            namePlural: "ClientSatisfactionQuestionnaires",
            namePluralFriendly: "Client Satisfaction Questionnaires",
            $type: "SeriouslyRAD.Framework.ClientAwareNameAttribute, SeriouslyRAD.Framework"
        }
    ],
    classHierarchy: [
        "GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire, GlobalMediation.Data.Entities",
        "SeriouslyRAD.Framework.Data.EntityBase, SeriouslyRAD.Framework.Data.Entities",
        "System.Object, System.Private.CoreLib"
    ],
    hasEnumFlags: false,
    name: "ClientSatisfactionQuestionnaire",
    properties: {
        ...EntityBaseProperties,
        caseId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Case"
                },
                {
                    entityDescriptionProperty: "ListDescription",
                    entityName: "Case",
                    entityNameFriendly: "Case",
                    entityNamePlural: "Cases",
                    entityNamePluralFriendly: "Cases",
                    foreignEntityAlias: "ClientSatisfactionQuestionnaires",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+CaseIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 0
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        name: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Name"
                },
                {
                    helpText: "Your Name",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+NameMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 1
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 64,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Name",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Date of Meeting"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+MeetingDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 2
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MeetingDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorName: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Name of Mediator"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+MediatorNameMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 3
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 64,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorName",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        sourceLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Source"
                },
                {
                    helpText: "Please tell us who you are:",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesBySource",
                    typeDescription: "CSQ Sources",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+SourceLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 4
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SourceLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        sourceOther: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Source Other"
                },
                {
                    helpText: "Please specify:",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+SourceOtherMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "SourceLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "0f9fd5f4-681d-4f9c-9e8a-55a7ce6281d4",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+SourceOtherRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 5
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 64,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SourceOther",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        quickReplyRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Quick Reply Rating"
                },
                {
                    helpText: "When I asked a question, I received a quick reply:",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByQuickReplyRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+QuickReplyRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 6
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "QuickReplyRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        contactCaseManagerRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Contact Case Manager Rating"
                },
                {
                    helpText: "I was able to contact the Case Manager:",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByContactCaseManagerRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+ContactCaseManagerRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 7
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ContactCaseManagerRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        happyWithSupportRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Happy With Support Rating"
                },
                {
                    helpText: "I was happy with the support I received:",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByHappyWithSupportRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+HappyWithSupportRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 8
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HappyWithSupportRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        clearInformationAboutMeetingRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Clear Information about Meeting Rating"
                },
                {
                    helpText: "I was given clear information about the meeting:",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByClearInformationAboutMeetingRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+ClearInformationAboutMeetingRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 9
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ClearInformationAboutMeetingRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseManagementTeamHelpComments: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Case Management Team Help Comments"
                },
                {
                    helpText: "Do you want to say anything about the help you received from the case management team?",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 10
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseManagementTeamHelpComments",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        helpWithTechnologyDuringMeetingRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Help with Technology during Meeting Rating"
                },
                {
                    helpText: "I was given information/help to join the meeting",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByHelpWithTechnologyDuringMeetingRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+HelpWithTechnologyDuringMeetingRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 11
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HelpWithTechnologyDuringMeetingRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        offeredConversationWithMediatorBeforeMeetingRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Offered Conversation with Mediator Before Meeting Rating"
                },
                {
                    helpText: "I was offered a telephone or online conversation with the mediator before the meeting",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByOfferedConversationWithMediatorBeforeMeetingRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+OfferedConversationWithMediatorBeforeMeetingRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 12
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "OfferedConversationWithMediatorBeforeMeetingRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorHelpBeforeMeetingComments: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediator Help before Meeting Comments"
                },
                {
                    helpText: "Do you want to say anything about the conversation you had with the mediator before the meeting?",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 13
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorHelpBeforeMeetingComments",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorHelpedMeFeelSafeAndComfortableRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediator Helped Me Feel Safe and Comfortable Rating"
                },
                {
                    helpText: "The mediator helped me feel safe and comfortable:",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByMediatorHelpedMeFeelSafeAndComfortableRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+MediatorHelpedMeFeelSafeAndComfortableRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 14
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorHelpedMeFeelSafeAndComfortableRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorWasFairRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediator was Fair Rating"
                },
                {
                    helpText: "The mediator was fair and did not take sides:",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByMediatorWasFairRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+MediatorWasFairRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 15
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorWasFairRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorListenedRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediator Listened Rating"
                },
                {
                    helpText: "The mediator listened to me:",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByMediatorListenedRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+MediatorListenedRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 16
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorListenedRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorMadeSurePointsHeardRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediator Made Sure Points Heard Rating"
                },
                {
                    helpText: "The mediator made sure my views and main points were heard:",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByMediatorMadeSurePointsHeardRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+MediatorMadeSurePointsHeardRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 17
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorMadeSurePointsHeardRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        happenNextRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Happen Next Rating"
                },
                {
                    helpText: "Before the meeting ended, I was told what would happen next:",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByHappenNextRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+HappenNextRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 18
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HappenNextRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        commentsAboutMediator: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Comments about Mediator"
                },
                {
                    helpText: "Do you want to say anything about the mediator? (For example, what they did well or what could have been better):",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 19
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CommentsAboutMediator",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationHelpfulRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Helpful Rating"
                },
                {
                    helpText: "I found the mediation helpful",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByMediationHelpfulRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+MediationHelpfulRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 20
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationHelpfulRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        recommendMediationRatingLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Recommend Mediation Rating"
                },
                {
                    helpText: "I would tell other people to try mediation",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "ClientSatisfactionQuestionnairesByRecommendMediationRating",
                    typeDescription: "CSQ Agree / Disagree Ratings",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+RecommendMediationRatingLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 21
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "RecommendMediationRatingLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingComments: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Meeting Comments"
                },
                {
                    helpText: "Do you want to say anything about the meeting? (For example, what was good or what stood out for you?):",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 22
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MeetingComments",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        suggestions: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Suggestions"
                },
                {
                    helpText: "Do you have any ideas about how we can make our service better?",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 23
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Suggestions",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        canContact: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Can Contact?"
                },
                {
                    helpText: "Can we contact you again to ask more questions later?",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+CanContactMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 24
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CanContact",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        canShareFeedback: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Can Share Feedback?"
                },
                {
                    helpText: "Can we share your feedback with other people to show how our service helps?",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+CanShareFeedbackMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 25
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CanShareFeedback",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        canUseNameOrOrganisationsName: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Can Use Name or Organisation's Name"
                },
                {
                    helpText: "Can we use your name or your organisation’s name with your comment?",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire+CanUseNameOrOrganisationsNameMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 26
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CanUseNameOrOrganisationsName",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        case: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Case",
            propertyTypeId: "GlobalMediation.Data.Entities.Case, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        clearInformationAboutMeetingRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ClearInformationAboutMeetingRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        contactCaseManagerRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ContactCaseManagerRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        happenNextRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HappenNextRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        happyWithSupportRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HappyWithSupportRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        helpWithTechnologyDuringMeetingRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HelpWithTechnologyDuringMeetingRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationHelpfulRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationHelpfulRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorHelpedMeFeelSafeAndComfortableRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorHelpedMeFeelSafeAndComfortableRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorListenedRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorListenedRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorMadeSurePointsHeardRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorMadeSurePointsHeardRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorWasFairRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorWasFairRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        offeredConversationWithMediatorBeforeMeetingRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "OfferedConversationWithMediatorBeforeMeetingRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        quickReplyRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "QuickReplyRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        recommendMediationRatingLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "RecommendMediationRatingLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        sourceLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SourceLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        }
    },
    underlyingTypeId: "GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire, GlobalMediation.Data.Entities",
    $type: "SeriouslyRAD.Framework.Reflection.TypeInfoMetadata, SeriouslyRAD.Framework"
};

